import React, { Component } from 'react';
import { Modal, message, DatePicker, Radio } from 'antd';
import ExportUtil from '../../../../common/ExportUtil';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import moment from "moment";

const RadioGroup = Radio.Group;
const { MonthPicker } = DatePicker;

class ExportFixedLine extends Component {
    state = {
        visible: false,
        confirmLoading: false,
        date: moment(),
    }
    
    show = () => {
        this.setState({
            fileType: '',
            visible: true,
        });
    };

    cancel = () => {
        this.setState({
            visible: false,
            date: moment(),
        });
    };

    query = () => {
        const { type } = this.props;
        let { date, fileType } = this.state;
        if (type === 'contractRecord' && !fileType) {
            message.warning('请选择固化数据导出方式');
            return;
        }
        const params = {
            fileType: type === 'contractRecord' ? fileType : 'JDE',
            investigationId: sessionStorage.getItem('invId') || 0,
            date: date.format('YYYY-MM'),
        };
        this.setState({ confirmLoading: true });
        const options = {
            url: `${API_URL.contract.checkFileFtp}`,
            data: { ...params },
            dataType: 'json',
            doneResult: ( data => {
                if (!data.error) {
                    this.submit({ ...params });
                } else {
                    message.error(data.error);
                }
                this.setState({ confirmLoading: false });
            }),
            errorResult: ( data => {
                this.setState({ confirmLoading: false });
            }),
        };
        $.sendRequest(options);
    }

    submit = params => {
        const { fileType = '' } = this.state;
        let url = ''
        if (fileType === 'FINANCE_CONTRACT_REBATE') {
            url = API_URL.contract.exportRebate;
        } else {
            url = API_URL.contract.getFileFtp;
        }
        ExportUtil.export(params, null, url);
        this.cancel();
    }

    disabledDate = current => {
        return current && current.valueOf() > moment().valueOf();
    }

    onChange = (date, dateString) => {
        if (date == null) {
            date = moment();
        }
        this.setState({ date });
    }

    onRadioChange = (e) => {
        this.setState({ fileType: e.target.value });
    }

    render () {
        const { type } = this.props;
        const { visible, confirmLoading, date, fileType = '' } = this.state;
        return (
            <Modal
                title="导出固化数据"
                visible={visible}
                onOk={this.query}
                onCancel={this.cancel}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
                confirmLoading={confirmLoading}
            >
                <div className="filter-bar">
                    <div className="filter-bar-investigation">                    
                        <div className="form-item">
                            <label htmlFor="" className="ui-label">请先选择固化月份</label>
                            <MonthPicker
                                disabledDate={this.disabledDate}
                                onChange={this.onChange}
                                placeholder="选择月份"
                                style={{width: 160}}
                                allowClear={true}
                                value={date}
                            />
                        </div>
                        {
                            type === 'contractRecord' &&
                            <div className="form-item">
                                <label className="ui-label">固化数据导出方式:</label>
                                <RadioGroup
                                    value={fileType}
                                    style={{marginLeft: 2, lineHeight: '28px',display:"grid"}}
                                    onChange={this.onRadioChange}
                                >
                                    <Radio value='JDE'>合同记录 (全部)</Radio>
                                    <Radio value='JDE_FINANCE'>合同记录 (财务版)</Radio>
                                    <Radio value='FINANCE_CONTRACT_REBATE'>rebate费记录 (财务版)</Radio>
                                </RadioGroup>
                            </div>
                        }
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ExportFixedLine;


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/components/ExportFixedLine.js